export const getters = {
    loadingFooter: state => state.loadingFooter,
    errorFooter: state => state.errorFooter,
    footer: state => state.footer
}